module.exports = __webpack_public_path__ + "static/bootstrap-table-bordered-d21ac920c831d6a4aff3138f598f9e75.png";